import { render, staticRenderFns } from "./DailyBlocks.vue?vue&type=template&id=6073dc30&scoped=true&"
import script from "./DailyBlocks.vue?vue&type=script&lang=js&"
export * from "./DailyBlocks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6073dc30",
  null
  
)

export default component.exports